var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "提款退款",
        visible: _setup.dialogVisible,
        width: "480px",
        "close-on-click-modal": false,
        "append-to-body": "",
      },
      on: {
        "update:visible": function ($event) {
          _setup.dialogVisible = $event
        },
        closed: _setup.handleClosed,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _setup.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    loading: _setup.submitting,
                  },
                  on: { click: _setup.submit },
                },
                [_vm._v("确定退款")]
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "el-form",
        { attrs: { "label-width": "80px", size: "small" } },
        [
          _c("el-form-item", { attrs: { label: "订单号" } }, [
            _c("span", [_vm._v(_vm._s(_vm.row && _vm.row.orderNo))]),
          ]),
          _c(
            "el-form-item",
            { attrs: { label: "备注" } },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  rows: 3,
                  maxlength: "200",
                  "show-word-limit": "",
                  placeholder: "选填",
                  clearable: "",
                },
                model: {
                  value: _setup.msg,
                  callback: function ($$v) {
                    _setup.msg = $$v
                  },
                  expression: "msg",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }